export default __webpack_public_path__ + "static/media/newfog3.752970fb.png";